import {sidenavItems } from '../models/auth.model';
import { LocationPermissionModel } from '../models/location.model';

export default class PPURouteBuilder {
  static createNavItems(permission: LocationPermissionModel) {
    const navItems = new Array<sidenavItems>();
    if (permission.pkgDropOff) {
      navItems.push({
        routerLink: 'dropoff',
        iconType: 'icons',
        iconClass: 'drop-off',
        title: 'Customer drop off',
        active: false,
      });
    }
    if (permission.pkgReceive) {
      navItems.push({
        routerLink: 'receive',
        iconType: 'icons',
        iconClass: 'package',
        title: 'Receive Packages',
        active: false,
      });
    }
    if (permission.pkgDeliver) {
      navItems.push({
        routerLink: 'deliver',
        iconType: 'icons',
        iconClass: 'deliver',
        title: 'Deliver to customer',
        active: false,
      });
    }

    if (permission.rts) {
      navItems.push({
        routerLink: 'returncourier',
        iconType: 'icons',
        iconClass: 'box-return',
        title: 'Return to courier',
        active: false,
      });
    }
    if (permission.pkgShipment) {
      navItems.push({
        routerLink: 'shippingtool',
        iconType: 'icons',
        iconClass: 'machool',
        title: 'Shipping tool',
        active: false,
      });
    }

    return navItems;
  }

  static getPermissionForRoute(url: string) {
    if (url.startsWith('/')) url = url.slice(1);
    
    url = url.split('/')[0];
    let result: String = '';
    switch (url) {
      case 'deliver':
        result = 'pkgDeliver';
        break;
      case 'receive':
        result = 'pkgReceive';
        break;
      case 'dropoff':
        result = 'pkgDropOff';
        break;
      case 'returncourier':
        result = 'rts';
        break;
      case 'shippingtool':
        result = 'pkgShipment';
        break;

    }
    return result;
  }

  static isValidRoute(permission: LocationPermissionModel, url: string): [boolean, string] {
    const permString = this.getPermissionForRoute(url);
    
    // If no permission mapping found, route is not permission-based (e.g., admin tool)
    if (!permString) {
      return [true, ''];
    }
    
    const str = permString as keyof typeof permission;
    let defaultRoute = '';
    const isvalid = <boolean>permission[str];
    if (isvalid) return [isvalid, ''];
    else {
      defaultRoute = this.createNavItems(permission).length > 0 ? this.createNavItems(permission)[0].routerLink : '';
      return [isvalid, defaultRoute];
    }
  }
}
